// src/infra/api/estacaoConfig.js
// Limite regulatório (FEPAM) de eficiência da estação — config por-tenant no CRM.
import axiosInstance from "../axios";

/** Lê o limite regulatório da estação (ou o default efetivo do backend). */
export const getEstacaoConfig = async () => {
    try {
        const { data } = await axiosInstance.get(`/estacao-config`);
        return data; // { limiteRegulatorio, bufferAtencao, atualizadoPorUserId, atualizadoEm }
    } catch (error) {
        throw new Error(
            error?.response?.data?.message || "Falha ao carregar a configuração da estação."
        );
    }
};

/** Salva o limite regulatório (ADMIN/GESTOR — backend responde 403 caso contrário). */
export const salvarEstacaoConfig = async ({ limiteRegulatorio, bufferAtencao }) => {
    try {
        const { data } = await axiosInstance.put(`/estacao-config`, {
            limiteRegulatorio,
            bufferAtencao,
        });
        return data;
    } catch (error) {
        throw new Error(
            error?.response?.data?.message || "Falha ao salvar o limite regulatório."
        );
    }
};
